if (!customElements.get('variant-picker')) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('.js-product');
      this.productForm = this.section.querySelector('.js-product-form');
      this.optionSelectors = this.querySelectorAll('.option-selector:not(.option-selector--custom)');
      this.nativeSelector = document.getElementById(`variants-${this.section.dataset.section}`);
      this.data = this.getVariantData();
      this.selectedOptions = this.getSelectedOptions();
      this.variant = this.getSelectedVariant();


      this.product_images_container = document.querySelector('media-gallery');
      this.product_images_desktop = this.product_images_container.querySelectorAll('.product-media-collage img');
      // this.template = document.querySelector('.js-media-zoom-template');

      this.querySelectorAll('input[type="radio"]').forEach(radio => {
        radio.addEventListener('click', () => {
          this.dispatchEvent(new CustomEvent('variant:change', {
            bubbles: true
          }));
          this.checkTierSelected(radio);
          function applyGlobalBasePriceAdjustments() {
            document.querySelectorAll('.product-form [data-product-collections] .money').forEach((element) => {
              const productWrapper = element.closest('[data-product-collections]');
              if (!productWrapper) return;
              // Skip if already has a markdown applied or if not an "original" or "default-title" variant
              if (
                productWrapper.dataset.discountedPrice !== undefined ||
                element.closest('[data-markdown-discounted="true"]') ||
                element.getAttribute('data-markdown-discounted') === 'true' ||
                (
                  element.closest('[data-current]') &&
                  !['original', 'default-title','original-standard','original-small'].includes(element.closest('[data-current]').dataset.current.toLowerCase())
                )
              ) {
                return;
              }
        
              const collections = productWrapper.dataset.productCollections
                ? productWrapper.dataset.productCollections.split(' ')
                : [];
        
              const variantTitle = productWrapper.dataset.current
                ? productWrapper.dataset.current.toLowerCase()
                : '';
        
              const priceText = element.textContent;
              const curr = theme.globals.userCurrency === 'GBP' ? '£' : '$';
        
              let prices = priceText.match(/[-+]?[0-9]*\.?[0-9]+/g);
              if (!prices) prices = [];
        
              let price_value = parseFloat(prices[0] || 0);
             
            });
          }
    
          setTimeout(() => {
            applyGlobalBasePriceAdjustments();
            if(MarkdownPricePro){
                  MarkdownPricePro.run();
            }
          }, 1000);
          
        });
      });

      // this.clonedContent = this.template.content.cloneNode(true);
      // this.gallery_viewer__thumbs = this.clonedContent.querySelectorAll('.gallery-viewer__thumb img');
      this.updateAvailability();
      this.updateAddToCartButton();
      this.addEventListener('change', this.handleVariantChange.bind(this));
      this.applySearchParams();
      this.selectDefaultTier();
      this.updateSettings();
      this.updateSelectedOptionLabels();

      this.setAttribute('loaded', '');
      
      // Initial price update and markdown run on load
      this.updatePrice(); 
    }


    /**
     * Helper to retrieve active markdown configuration data from the DOM/Cookie.
     * This is needed because the cookie state is unstable.
     */
    getActiveMarkdownConfig() {
        MarkdownPricePro.run();
    }


    /**
     * Handles 'change' events on the variant picker element.
     * @param {object} evt - Event object.
     */
    handleVariantChange(evt) {
      this.selectedOptions = this.getSelectedOptions();
      this.variant = this.getSelectedVariant();


      this.preSelection = !this.variant && this.selectedOptions.find((o) => o === null) === null;


      this.updateUrl(evt);
      this.updateVariantInput();
      this.updateAddToCartButton();
      this.updateAvailability();
      this.updatePrice(); // Calls _updatePriceElements -> RERUN MARKDOWN
      this.updateBackorderText();
      this.updatePickupAvailability();
      this.updateSku();
      this.updateBarcode();
      this.updateGallery();
      this.updateSettings();
      this.updateSelectedOptionLabels();

      if (evt.target.dataset.optionName === 'style') {
        this.checkTierSelected(evt.target);
      }


      VariantPicker.updateLabelText(evt);


      this.dispatchEvent(new CustomEvent('on:variant:change', {
        bubbles: true,
        detail: {
          form: this.productForm,
          variant: this.variant,
          allVariants: this.data.variants,
          selectedOptions: this.selectedOptions
        }
      }));
      MarkdownPricePro.run();
    }
    reinitialize() {
      // Re-run the core logic from the constructor
      this.section = this.closest('.js-product');
      this.productForm = this.section.querySelector('.js-product-form');
      this.optionSelectors = this.querySelectorAll('.option-selector:not(.option-selector--custom)');
      this.nativeSelector = document.getElementById(`variants-${this.section.dataset.section}`);
      this.data = this.getVariantData();
      this.selectedOptions = this.getSelectedOptions();
      this.variant = this.getSelectedVariant();
      
      // Since the event listener is already attached in the constructor, 
      // we only need to update the initial state.
      this.updateAvailability();
      this.updateAddToCartButton();
      this.updatePrice(); // Ensure price is correct for the initial variant
      // No need to re-add the 'change' listener.


      this.setAttribute('loaded', '');
    }
    /**
     * Updates the "Add to Cart" button label and status.
     */
    updateAddToCartButton() {
      if (!this.productForm) return;
      // ONLY check for pre-selection if the default option-selectors are used
      if (this.optionSelectors.length > 0 && this.selectedOptions.indexOf(null) > -1) return;

      this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]');
      const addToCartBtn = document.querySelector('product-form .add-to-cart');
      const variantAvailable = this.variant && this.variant.available;
      const unavailableStr = this.variant ? theme.strings.noStock : theme.strings.noVariant;
      if (!addToCartBtn.dataset.initialState) {
        addToCartBtn.dataset.initialState = 'true';
        addToCartBtn.disabled = true;
      }

      if (variantAvailable) {
        addToCartBtn.removeAttribute('disabled');
        addToCartBtn.disabled = false;
        addToCartBtn.style.display = "block";
        
        // Remove notify button if it exists when variant becomes available
        const existingNotify = this.productForm.querySelector('.custom-swym-notify');
        if (existingNotify) existingNotify.remove();
      } else {
        addToCartBtn.disabled = true;
        addToCartBtn.style.display = "none";
        
        // Run notify button initializer when variant is unavailable/sold-out
        setTimeout(initCustomSwymNotifyButton, 2500);
      }

      // Use the text stored in the button's data attribute
      addToCartBtn.textContent = variantAvailable
        ? addToCartBtn.dataset.addToCartText
        : unavailableStr;
      
      // Use the selected option if no matching variant exists (e.g. sold out / unavailable)
      const styleOption = this.selectedOptions?.[0]?.toLowerCase() || '';
      const title = (this.variant?.title || styleOption).toLowerCase();

      const colorush = document.querySelector('.sr-colorush');
      const pro = document.querySelector('.sr-pro');

      const isColorush = title.includes('colorush') || styleOption.includes('colorush');
      const isPro = title.includes('pro') || styleOption.includes('pro');

      // Default (Original): hide both
      if (colorush) colorush.classList.add('hidden');
      if (pro) pro.classList.add('hidden');

      // Colorush: show only Colorush
      if (isColorush) {
        if (colorush) colorush.classList.remove('hidden');
        if (pro) pro.classList.add('hidden');
      }

      // Pro: show only Pro
      if (isPro) {
        if (pro) pro.classList.remove('hidden');
        if (colorush) colorush.classList.add('hidden');
      }

      let isOriginal = title.includes('original');

      document.querySelectorAll('.view-cart-link').forEach(el => {
            el.style.setProperty('display', 'none');
      });
      


    }


    /**
     * Updates the availability status of an option.
     * @param {Element} optionEl - Option element.
     * @param {boolean} exists - Does this option lead to a variant that exists?
     * @param {boolean} available - Does this option lead to a variant that is available to buy?
     */
    static updateOptionAvailability(optionEl, exists, available) {
      const el = optionEl;
      const unavailableText = exists ? theme.strings.noStock : theme.strings.noVariant;
      
      const variantItem = el.closest('.variant-item'); // Find the entire option block container

      el.classList.toggle('is-unavailable', !available);
      el.classList.toggle('is-nonexistent', !exists);

      // CRITICAL FIX FOR HIDING: Hide the entire option block if the variant combination does not exist
      if (variantItem) {
          // Use classList toggle to enable hiding via CSS with !important if needed
          variantItem.classList.toggle('is-hidden-variant-item', !exists);
      }

      // The rest of the original logic to show text/titles
      if (optionEl.classList.contains('custom-select__option')) {
        const em = el.querySelector('em');


        if (em) {
          em.hidden = available;
        }


        if (!available) {
          if (em) {
            em.textContent = unavailableText;
          } else {
            el.innerHTML = `${el.innerHTML} <em class="pointer-events-none">${unavailableText}</em>`;
          }
        }
      } else if (!available) {
        el.nextElementSibling.title = unavailableText;
      } else {
        el.nextElementSibling.removeAttribute('title');
      }
    }


    /**
     * Updates the availability status in option selectors.
     */
    updateAvailability() {
      if (this.dataset.availability === 'off') return;
      const { availabilityMode } = this.dataset; // 'down' or 'selection'
      let currVariant = this.variant;


      if (!this.variant) {
        currVariant = { options: this.selectedOptions };
      }


      if (availabilityMode === 'selection') {
        // Flag all options as unavailable
        this.querySelectorAll('.js-option').forEach((optionEl) => {
          VariantPicker.updateOptionAvailability(optionEl, false, false);
        });


        // Flag selector options as available or sold out, depending on the variant availability
        this.optionSelectors.forEach((selector, selectorIndex) => {
          this.data.variants.forEach((variant) => {
            let matchCount = 0;


            variant.options.forEach((option, optionIndex) => {
              if (option === currVariant.options[optionIndex] && optionIndex !== selectorIndex) {
                matchCount += 1;
              }
            });


            if (matchCount === currVariant.options.length - 1) {
              const options = selector.querySelectorAll('.js-option');
              const optionEl = Array.from(options).find((opt) => {
                if (selector.dataset.selectorType === 'dropdown') {
                  return opt.dataset.value === variant.options[selectorIndex];
                }
                return opt.value === variant.options[selectorIndex];
              });


              if (optionEl) {
                VariantPicker.updateOptionAvailability(optionEl, true, variant.available);
              }
            }
          });
        });
      } else {
        this.optionSelectors.forEach((selector, selectorIndex) => {
          const options = selector.querySelectorAll('.js-option:not([data-value=""])');
          options.forEach((option) => {
            const optionValue = selector.dataset.selectorType === 'dropdown' ? option.dataset.value : option.value;
            // any available variants with previous options and this one locked in?
            let variantsExist = false;
            let variantsAvailable = false;
            this.data.variants.forEach((v) => {
              let matches = 0;
              for (let i = 0; i < selectorIndex; i += 1) {
                if (v.options[i] === this.selectedOptions[i] || this.selectedOptions[i] === null) {
                  matches += 1;
                }
              }
              if (v.options[selectorIndex] === optionValue && matches === selectorIndex) {
                variantsExist = true;
                if (v.available) {
                  variantsAvailable = true;
                }
              }
            });
            VariantPicker.updateOptionAvailability(option, variantsExist, variantsAvailable);
          });
                // If the selected option was hidden (doesn't exist for the current selection),
      // automatically select the first visible option.
      if (selector.dataset.selectorType !== 'dropdown') {
        const checked = selector.querySelector('input:checked');

        if (checked) {
          const checkedItem = checked.closest('.variant-item');

          if (checkedItem && checkedItem.classList.contains('is-hidden-variant-item')) {
            const fallback = Array.from(
              selector.querySelectorAll('input.js-option')
            ).find((input) => {
              const item = input.closest('.variant-item');

              return (
                item &&
                !item.classList.contains('is-hidden-variant-item') &&
                !input.disabled
              );
            });

            if (fallback && fallback !== checked) {
              fallback.checked = true;

              // Trigger the normal variant update flow
              fallback.dispatchEvent(
                new Event('change', {
                  bubbles: true
                })
              );

              return;
            }
          }
        }
      }
        });
      }
    }


    /**
     * Updates the backorder text and visibility.
     */
    updateBackorderText() {
      this.backorder = this.backorder || this.section.querySelector('.backorder');
      if (!this.backorder) return;


      let hideBackorder = true;


      if (this.variant && this.variant.available) {
        const { inventory } = this.data.formatted[this.variant.id];


        if (this.variant.inventory_management && inventory === 'none') {
          const backorderProdEl = this.backorder.querySelector('.backorder__product');
          const prodTitleEl = this.section.querySelector('.product-title');
          const variantTitle = this.variant.title.includes('Default') ? '' : ` - ${this.variant.title}`;


          backorderProdEl.textContent = `${prodTitleEl.textContent}${variantTitle}`;
          hideBackorder = false;
        }
      }


      this.backorder.hidden = hideBackorder;
    }


    /**
     * Updates the colour option label text.
     * @param {object} evt - Event object
     */
    static updateLabelText(evt) {
      const selector = evt.target.closest('.option-selector');
      if (selector.dataset.selectorType === 'dropdown') return;


      const colorText = selector.querySelector('.js-color-text');
      if (!colorText) return;


      colorText.textContent = evt.target.nextElementSibling.querySelector('.js-value').textContent;
    }


    /**
     * Updates the pick up availability.
     */
    updatePickupAvailability() {
      this.pickUpAvailability = this.pickUpAvailability || this.section.querySelector('pickup-availability');
      if (!this.pickUpAvailability) return;


      if (this.variant && this.variant.available) {
        this.pickUpAvailability.getAvailability(this.variant.id);
      } else {
        this.pickUpAvailability.removeAttribute('available');
        this.pickUpAvailability.innerHTML = '';
      }
    }


    _updatePriceElements() {
      this.price = this.price || this.section.querySelector('.price');
      if (!this.price) return;

      const metadataWrapper = this.price.querySelector('[data-product-collections]') || 
                              this.section.querySelector('[data-product-collections]') ||
                              this.price.querySelector('.price__default');
      
      if (!metadataWrapper) return;

      const collections = metadataWrapper.dataset.productCollections || '';
      const mainDisplayVariant = this.variant || this.data.variants[0];
      const mainPriceData = this.data.formatted[mainDisplayVariant.id];

      const currentContainer = this.price.querySelector('.price__current');
      if (currentContainer) {
          const isOnSale = mainDisplayVariant.compare_at_price > mainDisplayVariant.price;
          
          // Only the selling price lives inside .price__current. The compare-at
          // price is the single .price__was sibling rendered by snippets/price.liquid,
          // which is updated (or created/removed) here so the old variant's
          // compare-at price is replaced instead of being shown twice.
          if (isOnSale) {
              currentContainer.innerHTML = `
                <span class="price--on-sale" data-target="price-element">
                  <span class="price-label money">${mainPriceData.price}</span>
                </span>`;
          } else {
              currentContainer.innerHTML = `<span data-target="price-element">${mainPriceData.price}</span>`;
          }

          const priceWrapper = currentContainer.parentElement;
          let wasEl = priceWrapper
            ? Array.from(priceWrapper.children).find((el) => el.classList.contains('price__was'))
            : null;

          if (isOnSale) {
              if (!wasEl && priceWrapper) {
                  wasEl = document.createElement('span');
                  wasEl.className = 'price__was';
                  currentContainer.insertAdjacentElement('afterend', wasEl);
              }
              if (wasEl) {
                  wasEl.innerHTML = mainPriceData.compareAtPrice;
                  wasEl.hidden = false;
              }
          } else if (wasEl) {
              wasEl.remove();
          }

          this.price.classList.toggle('price--on-sale', isOnSale);
      }
      
      metadataWrapper.dataset.productSelectedVariant = mainDisplayVariant.title;
      metadataWrapper.dataset.realPrice = mainDisplayVariant.price;
      metadataWrapper.dataset.current = mainDisplayVariant.title.toLowerCase().trim();

      const firstOptionSelector = this.optionSelectors[0];
      if (firstOptionSelector && (firstOptionSelector.classList.contains('style__selector') || firstOptionSelector.dataset.optionName === 'style')) {
          this._updateTierPrices(firstOptionSelector, collections);
      }
      
      if (typeof window.MarkdownPricePro !== 'undefined' && typeof window.MarkdownPricePro.run === 'function') {
          window.MarkdownPricePro.run({ is_product_page: true, skipReset: true });
      }
    }
    updateSelectedOptionLabels() {
      const lensTitle = this.section.querySelector('.sr-pdp-tier-title');
      const frameTitle = this.section.querySelector('.sr-pdp-frame-title');
    
      const selectedStyle = this.querySelector('input[data-option-name="style"]:checked');
      const selectedSize = this.querySelector('input[data-option-name="size"]:checked');
    
      if (lensTitle) {
        const lensValue =
          selectedStyle?.dataset.optionValue ||
          selectedStyle?.value ||
          '';
    
        lensTitle.textContent = `Lens: ${lensValue}`;
      }
    
      if (frameTitle) {
        const sizeValue =
          selectedSize?.dataset.optionValue ||
          selectedSize?.value ||
          '';
    
        frameTitle.textContent = `Size: ${sizeValue}`;
      }
    }
    /**
     * Renamed function to avoid conflict/confusion with price logic
     */
    updatePrice() {
        if (typeof window.MarkdownPricePro !== 'undefined' && window.MarkdownPricePro.init) {
            const config = this.getActiveMarkdownConfig();
            if (config && config.id && config.collections && config.multiplier) {
                // Force re-initialization to ensure the cookie state is valid before running the update
                window.MarkdownPricePro.init({
                    id: config.id,
                    collections: config.collections,
                    multiplier: config.multiplier,
                    discount_code: config.discount_code, // Pass all necessary parameters
                    // Keep defaults for others like expires, autoApplyCoupon, etc.
                });
            }
        }
        
        this._updatePriceElements();
        
    }

  _updateTierPrices(selector, collections) {
    const currentSizeValue = this.selectedOptions[1];
    selector.querySelectorAll('input[type="radio"]').forEach(tierInput => {
       
        const tierValue = tierInput.value;

      let vToPrice = this.data.variants.find(
        v => v.options[0] === tierValue && v.options[1] === currentSizeValue
      );
      if (!vToPrice) {
        vToPrice = this.data.variants.find(v => v.options[0] === tierValue);
      }

      const labelSpan = tierInput.nextElementSibling?.querySelector('span[data-current]');

      const moneyFormat = window.theme?.moneyFormat || window.Shopify?.money_format || '${{amount_no_decimals}}';

     
      const formatMoney = (cents) => {
        const currencyCode = window.Shopify?.currency?.active || 'USD';

        const symbolMap = {
          USD: '$',
          CAD: '$',
          AUD: '$',
          GBP: '£',
          EUR: '€'
        };

        const symbol = symbolMap[currencyCode] || '$';
        const amount = Math.round(Number(cents) / 100);

        return `${symbol}${amount}`;
      };

      if (vToPrice && labelSpan) {
        const isOnSale = vToPrice.compare_at_price > vToPrice.price;

        const formattedPrice = formatMoney(vToPrice.price);
        const formattedCompare = vToPrice.compare_at_price
          ? formatMoney(vToPrice.compare_at_price)
          : null;

        if (isOnSale) {
          labelSpan.innerHTML = `
            <span class="price--on-sale" data-target="price-element">
              <span class="js-value value-price">${formattedPrice}</span>
              <span class="price__was mini-price">${formattedCompare}</span>
            </span>`;
        } else {
          labelSpan.innerHTML = `
            <span class="js-value value-price" data-target="price-element">
              ${formattedPrice}
            </span>`;
        }

        labelSpan.dataset.realPrice = vToPrice.price;
        labelSpan.dataset.productCollections = collections;
        labelSpan.dataset.current = tierValue.toLowerCase();
      }
    });
  }
    /**
     * Updates the SKU.
     */
    updateSku() {
      this.sku = this.sku || this.section.querySelector('.product-sku__value');
      if (!this.sku) return;


      const skuAvailable = this.variant && this.variant.sku;
      this.sku.textContent = skuAvailable ? this.variant.sku : '';
      this.sku.parentNode.hidden = !skuAvailable;
    }


    /**
     * Updates the Barcode.
     */
    updateBarcode() {
      this.barcode = this.barcode || this.section.querySelector('.product-barcode__value');
      if (!this.barcode) return;


      const barcodeAvailable = this.variant && this.variant.barcode;
      this.barcode.textContent = barcodeAvailable ? this.variant.barcode : '';
      this.barcode.parentNode.hidden = !barcodeAvailable;
    }


    /**
     * Updates the url with the selected variant id.
     * @param {object} evt - Event object.
     */
    updateUrl(evt) {
      if (!evt || evt.type !== 'change' || this.dataset.updateUrl === 'false' || document.body.classList.contains('template-collection')) return;
      const url = this.variant ? `${this.dataset.url}?variant=${this.variant.id}` : this.dataset.url;
      window.history.replaceState({}, '', url);
    }


    /**
     * Updates the value of the hidden [name="id"] form inputs.
     */
    updateVariantInput() {
      this.forms = this.forms || this.section.querySelectorAll('.js-product-form, .js-instalments-form');


      this.forms.forEach((form) => {
        const input = form.querySelector('[name="id"]');
        input.value = this.variant ? this.variant.id : '';
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }


    /**
     * Gets the variant data for a product.
     * @returns {?object}
     */
    getVariantData() {
      const dataEl = this.querySelector('[type="application/json"]');
      return JSON.parse(dataEl.textContent);
    }


    /**
     * Get the selected values from a list of variant options.
     * @returns {Array} Array of selected option values, value is null if not selected.
     */
    getSelectedOptions() {
      const selectedOptions = []; // CORRECTED: Declared locally using const

      this.optionSelectors.forEach((selector) => {
        if (selector.dataset.selectorType === 'dropdown') {
          const selected = selector.querySelector('.custom-select__option[aria-selected="true"]');
          selectedOptions.push(selected && selected.dataset.value !== '' ? selected.dataset.value : null);
        } else {
          // Use the unique radio button name for reliable selection
          const firstInput = selector.querySelector('input[type="radio"]');
          if (firstInput) {
             const nameAttr = firstInput.name;
             // Query the whole document for the checked input with that specific name
             const selected = document.querySelector(`input[name="${nameAttr}"]:checked`);
             selectedOptions.push(selected ? selected.value : null);
          } else {
             // Fallback for unexpected structure
             const selected = selector.querySelector('input:checked');
             selectedOptions.push(selected ? selected.value : null);
          }
        }
      });

      return selectedOptions;
    }


    /**
     * Get selected variant data.
     * @returns {?object} Variant object, or null if one is not selected.
     */
    getSelectedVariant() {
      return this.data.variants.find(
        (v) => v.options.every((val, index) => val === this.selectedOptions[index])
      );
    }


    /**
     * Apply search parameters.
     */
    applySearchParams() {
      const searchParams = new URLSearchParams(window.location.search);


      Array.from(searchParams.keys()).forEach((key) => {
        const value = searchParams.get(key);
        const optionSelectors = Array.from(this.optionSelectors);
        const matchingOptionSelector = optionSelectors.find((x) => x.dataset.option === key);
        if (!matchingOptionSelector) return;


        if (matchingOptionSelector.dataset.selectorType === 'dropdown') {
          const colorOptionDropdown = matchingOptionSelector.querySelector(`.custom-select__option[data-value="${value}"]`);
          if (colorOptionDropdown) {
            const customSelect = colorOptionDropdown.closest('custom-select');
            customSelect.selectOption(colorOptionDropdown);
          }
        } else {
          const matchingInput = matchingOptionSelector.querySelector(`input[value="${value}"]`);
          if (matchingInput) {
            const matchingOptionValue = matchingOptionSelector.querySelector('.option-selector__label-value');
            if (matchingOptionValue) {
              matchingOptionSelector.querySelector('.option-selector__label-value').textContent = value;
            }
            matchingInput.checked = true;
            matchingInput.dispatchEvent(
              new CustomEvent('change', { bubbles: true, cancelable: false })
            );
          }
        }
      });
    }


    /**
     * Update Gallery Images.
     */
    updateGallery(evt) {


    }


    checkTierSelected(evt) {
      const p_original = document.querySelector('.prod-default-content');
      const p_pro = document.querySelector('.ascend-standard');
      const p_colorush = document.querySelector('.colorush-standard');
      const section_colorush = document.querySelectorAll('.tier_colorush');
      const section_srpro = document.querySelectorAll('.tier_srpro');


      //window.alert(evt.dataset.optionId);


      if (p_original)
        p_original.classList.add('hidden');


      if (p_pro)
        p_pro.classList.add('hidden');


      if (p_colorush)
        p_colorush.classList.add('hidden');


      if (section_colorush) {
        section_colorush.forEach((section) => {
          section.classList.add("hidden");
        });
      }


      if (section_srpro) {
        section_srpro.forEach((section) => {
          section.classList.add("hidden");
        });
      }


      if (evt.dataset.tier) {

        const productHandle = this.dataset.url
          ? this.dataset.url.replace('/products/', '').split('?')[0]
          : window.location.pathname.split('/products/')[1]?.split('?')[0];

        /*
        this.getVariantsByHandle(productHandle).then(() => {
          this.updateTierPricing(evt);
        });
        */

        switch (evt.dataset.tier) {
          case 'original':
            if(p_original){
              p_original.classList.remove('hidden');
            }
            this.swapImages(evt, evt.dataset.imgs);
            break;


          case 'pro-polarized':
            if(p_pro){
              p_pro.classList.remove('hidden');
            }
            if (section_srpro) {
              section_srpro.forEach((section) => {
                section.classList.remove("hidden");
              });
            }
            this.swapImages(evt, evt.dataset.proImgs);
            break;


          case 'colorush':
            if(p_colorush){
              p_colorush.classList.remove('hidden');
            }
            if (section_colorush) {
              section_colorush.forEach((section) => {
                section.classList.remove("hidden");
              });
            }
            if(evt.dataset.skipSwapimage==='false')
              this.swapImages(evt, evt.dataset.colorushImgs);
            break;
        }
      }
    }

    getVariantsByHandle(handle) {
      if (!handle) return Promise.resolve(null);

      if (window.curProdroduct && window.curProdroduct.handle === handle) {
        return Promise.resolve(window.curProdroduct);
      }
     
      return fetch('/products/' + handle + '.js')
        .then(response => response.json())
        .then(product => {
          window.curProdroduct = {
            product_id: product.id,
            handle: product.handle,
            title: product.title,
            selected_variant_id: product.variants[0]?.id,
            variants: {
              original: 0,
              pro: 0,
              colorush: 0
            }
          };
          
          product.variants.forEach(variant => {
            const title = variant.title.toLowerCase();

            if (title.includes('colorush') && !window.curProdroduct.variants.colorush) {
              window.curProdroduct.variants.colorush = variant.price / 100;
            } else if (title.includes('pro') && !window.curProdroduct.variants.pro) {
              window.curProdroduct.variants.pro = variant.price / 100;
            } else if (title.includes('original') && !window.curProdroduct.variants.original) {
              window.curProdroduct.variants.original = variant.price / 100;
            }
          });

          return window.curProdroduct;
        })
        .catch(error => {
          console.error('getVariantsByHandle error:', error);
          return null;
        });
    }

    getCookieValue(name) {
      return document.cookie
        .split('; ')
        .find(row => row.startsWith(name + '='))
        ?.split('=')[1] || '';
    }

    updateTierPricing(target) {
      const tier_container = this.getItemKeyContainer(target.dataset.tier);
      const tier_name = this.getItemKey(target.dataset.tier);
      const markdownDiscountCode = this.getCookie?.('markdown_discount_code') || this.getCookieValue?.('markdown_discount_code');

      if (markdownDiscountCode) {
        return;
      }

      let selectedPrice = 0;

      if (
        curProdroduct &&
        curProdroduct.variants &&
        Object.keys(curProdroduct.variants).length > 1
      ) {
        Object.entries(curProdroduct.variants).forEach(([key, price]) => {
          if (key === tier_name) {
            selectedPrice = parseFloat(price) || 0;
          }
        });
      }

      setTimeout(() => {
        //if (!document.body.classList.contains('PLUS-PRICE-B')) return;

        this.querySelectorAll('.variant-item').forEach((optionEl) => {
          const priceContainer = optionEl.querySelector('[data-target="price-element"]');
          if (!priceContainer || priceContainer.classList.contains('price--on-sale')) return;

          const moneyEl = priceContainer.querySelector('.money');
          const variantPrice = priceContainer.querySelector('.variant-price');

          let diffEl = priceContainer.querySelector('.price-diff');

          if (!diffEl) {
            diffEl = document.createElement('span');
            diffEl.className = 'price-diff';
            priceContainer.appendChild(diffEl);
          }

          if (!optionEl.classList.contains(tier_container)) {
            if (moneyEl) moneyEl.style.display = 'none';
            if (variantPrice) variantPrice.style.display = 'none';
          }

          if (optionEl.classList.contains('item-original')) {
            diffEl.innerHTML = this.formatDiff(parseFloat(curProdroduct.variants.original || 0), selectedPrice);
          } else if (optionEl.classList.contains('item-pro-polarized')) {
            diffEl.innerHTML = this.formatDiff(parseFloat(curProdroduct.variants.pro || 0), selectedPrice);
          } else if (optionEl.classList.contains('item-colorush')) {
            diffEl.innerHTML = this.formatDiff(parseFloat(curProdroduct.variants.colorush || 0), selectedPrice);
          }
        });

        this.querySelectorAll('.variant-item').forEach((optionEl) => {
          const priceContainer = optionEl.querySelector('[data-target="price-element"]');
          const priceDiff = priceContainer?.querySelector('.price-diff');
          const radio = optionEl.querySelector('input[type="radio"]');

          if (!priceContainer || !priceDiff) return;
          if (!radio?.checked) {
              priceContainer.innerHTML = '';
              priceContainer.appendChild(priceDiff);
          }
        });


        const selectedItem = this.querySelector('.variant-item.' + tier_container);

        if (selectedItem) {
          const priceContainer = selectedItem.querySelector('[data-target="price-element"]');
          if (!priceContainer) return;

          const moneyEl = priceContainer.querySelector('.money');
          const variantPrice = priceContainer.querySelector('.variant-price');
          const diffEl = priceContainer.querySelector('.price-diff');

          if (moneyEl) moneyEl.style.display = 'inline';
          if (variantPrice) variantPrice.style.display = 'inline';
          if (diffEl) diffEl.innerHTML = '';

          //const priceElement = document.querySelector('[data-target="price-element"]');
          //const priceDiff = priceElement?.querySelector('.price-diff');

          // if (priceElement && priceDiff) {
          //   priceElement.innerHTML = '';
          //   priceElement.appendChild(priceDiff);
          // }

        }

      }, 100);
    }

    formatDiff(price, selectedPrice) {
      const diff = price - selectedPrice;
      const currencySymbol = this.getCurrencySymbol();

      const roundedDiff = Math.round(Math.abs(diff));

      if (diff > 0) return `+${currencySymbol}${roundedDiff}`;
      if (diff < 0) return `-${currencySymbol}${roundedDiff}`;

      return '';
    }

    getCurrencySymbol() {
      const code = Shopify.currency.active || 'USD';

      const map = {
        USD: '$',
        CAD: '$',
        AUD: '$',
        GBP: '£',
      };

      return map[code] || '$';
    }
    getItemKeyContainer(item) {
      if (item.includes('original')) return 'item-original';
      if (item.includes('pro')) return 'item-pro-polarized';
      if (item.includes('colorush')) return 'item-colorush';
      return null;
    }

    getItemKey(item) {
      if (item.includes('original')) return 'original';
      if (item.includes('pro')) return 'pro';
      if (item.includes('colorush')) return 'colorush';
      return null;
    }

    // swapImages(selected_tier, imgs) {
    //   const imgs_arr = imgs.split(',');


    //   if (selected_tier) {
    //     /*
    //     this.product_images_desktop.forEach((img, index) => {
    //       img.src = imgs_arr[index];
    //       img.setAttribute('srcset', imgs_arr[index]);
    //       const threeLevelParent = img.parentElement?.parentElement?.parentElement;
    //       threeLevelParent.href=imgs_arr[index];
    //       //console.log(`Image ${index}:`, imgs_arr[index]);
    //     });
    //     */
    //     const pdp_thumb_imgs = document.querySelectorAll('[data-pdp-gallery="original"]');
    //     const pdp_slider_gallery = document.querySelectorAll('[data-pdp-slider="original"]');
    //     const pdp_all_thumbs = document.querySelectorAll('ul.slider__grid .slider__item');
    //     pdp_thumb_imgs.forEach((el, index) => {
    //       const img = el.querySelector('img');
    //       const a = el.querySelector('a');
    //       if (img) {
    //         a.href = imgs_arr[index];
    //         img.src = imgs_arr[index];
    //         img.setAttribute('srcset', imgs_arr[index]);
    //         //console.log(`Image ${index}:`, img.src);
    //       }
    //     });


    //     pdp_slider_gallery.forEach((el, index) => {
    //       const img = el.querySelector('img');
    //       if (img) {
    //         img.src = imgs_arr[index];
    //         img.setAttribute('srcset', imgs_arr[index]);
    //         //console.log(`Image ${index}:`, img.src);
    //       }
    //     });
    //     pdp_all_thumbs.forEach((el, index) => {
    //       const img = el.querySelector('img');
    //       const a = el.querySelector('a');
    //     });


    //     const observer = new MutationObserver((mutations, obs) => {
    //         const thumbs = document.querySelector('.gallery-viewer__thumbs');
    //         if (thumbs) {
    //             /*
    //             const thumbElement = createThumbElement(mediaId, imageUrl);
    //             const thumbChildren = thumbs.children;
    //             thumbs.insertBefore(thumbElement, thumbChildren[3]);
    //             */
    //             console.log('Gallery thumbs updated');
    //             obs.disconnect();
    //         }
    //     });


    //     observer.observe(document.body, { childList: true, subtree: true });


    //     // this.gallery_viewer__thumbs.forEach((img, index) => {
    //     //   const newSrc = imgs_arr[index];
    //     //   if (newSrc) {
    //     //     img.src = newSrc;
    //     //     img.setAttribute('srcset', newSrc);
    //     //     const anchor = img.closest('a.gallery-viewer__thumb');
    //     //     if (anchor) {
    //     //       anchor.href = newSrc;
    //     //       anchor.setAttribute('data-zoom-url', newSrc);
    //     //     }
    //     //   }
    //     // });
    //   }
    // }
swapImages(selected_tier, imgs) {
  const imgs_arr = imgs.split(',').map(s => s.trim()).filter(Boolean);

  if (selected_tier) {
    const pdp_thumb_imgs = document.querySelectorAll('[data-pdp-gallery="original"]');
    const pdp_slider_gallery = document.querySelectorAll('[data-pdp-slider="original"]');
    const pdp_all_thumbs = document.querySelectorAll('ul.slider__grid .slider__item');

    const hideSlide = (el) => {
      el.classList.add('hidden');
      el.setAttribute('hidden', '');
    };

    const showSlide = (el) => {
      el.classList.remove('hidden');
      el.removeAttribute('hidden');
    };

    const setImageWithFallback = (el, img, src) => {
      // No URL for this slot at all -> hide immediately, no request needed
      if (!src) {
        hideSlide(el);
        return;
      }

      showSlide(el);

      // Clear any previous error state from a prior tier switch
      img.onerror = null;

      img.onerror = () => {
        hideSlide(el);
      };
      img.onload = () => {
        showSlide(el);
      };

      img.src = src;
      img.setAttribute('srcset', src);
    };

    pdp_thumb_imgs.forEach((el, index) => {
      const img = el.querySelector('img');
      const a = el.querySelector('a');
      const src = imgs_arr[index];

      if (!img) return;

      setImageWithFallback(el, img, src);

      if (a) {
        if (src) {
          a.href = src;
        } else {
          a.removeAttribute('href');
        }
      }
    });

    pdp_slider_gallery.forEach((el, index) => {
      const img = el.querySelector('img');
      const src = imgs_arr[index];

      if (!img) return;

      setImageWithFallback(el, img, src);
    });

    pdp_all_thumbs.forEach((el, index) => {
      const img = el.querySelector('img');
      const a = el.querySelector('a');
      // left as-is — no src assignment was happening here before either
    });

    const observer = new MutationObserver((mutations, obs) => {
      const thumbs = document.querySelector('.gallery-viewer__thumbs');
      if (thumbs) {
        console.log('Gallery thumbs updated');
        obs.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }
}
    selectDefaultTier() {
      const params = new URLSearchParams(window.location.search);
      if (params.has('variant')) return;

      const referrer = document.referrer.toLowerCase();

      let tier = 'original';

      if (
        referrer.includes('/collections/men-colorush') ||
        referrer.includes('/collections/women-colorush') ||
        referrer.includes('/collections/colorush')
      ) {
        tier = 'colorush';
      } else if (
        referrer.includes('/collections/pro-polarized')
      ) {
        tier = 'pro-polarized';
      }

      const input = this.querySelector(`input[data-tier="${tier}"]`);

      if (input && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    updateSettings() {
      const fit_guides_all = document.querySelectorAll(".fit-guide__wrapper .fgs-size");
      const fit_images_all = document.querySelectorAll(".sr-size-imgs");
      const selected_style = document.querySelector('input[data-option-name="style"]:checked');
      const prescriptions = document.querySelectorAll('a.available-pres');
      const selected_size = document.querySelector('input[data-option-name="size"]:checked');


      fit_guides_all.forEach((fitOption) => {
        fitOption.classList.add('hide');
      });
      fit_images_all.forEach((fitOption) => {
        fitOption.classList.add('hide');
      });


      prescriptions.forEach((fitOption) => {
        if (fitOption.dataset.oneSize !== "true") {
          fitOption.classList.add('hidden');
        }
      });


      if (selected_size) {
        const fit_guide_to_show = document.querySelectorAll(`[data-product-size="${selected_size.dataset.optionValue}"]`);


        fit_guide_to_show.forEach((fitOption) => {
          fitOption.classList.remove('hide');
          fitOption.classList.remove('hidden');
        });
      }
      if (selected_style) {
        this.checkTierSelected(selected_style);
        this.updateSelectedOptionLabels();
      }
    }
  }


  customElements.define('variant-picker', VariantPicker);
}

function initCustomSwymNotifyButton() {
  try {
    const form = document.querySelector('product-form');

    const soldOutBtn = form.querySelector('button[name="add"][disabled]');

    // If Swym app already injected its own Notify button and it's visible,
    // remove our custom button (if exists) and stop execution
    const swymInjectedBtn = form.querySelector(
      '.swym-button.swym-notify-btn, .swym-added-to-waitlist, .swym-button-bar button'
    );

    if (swymInjectedBtn) {
      const style = window.getComputedStyle(swymInjectedBtn);
      const isVisible =
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        swymInjectedBtn.offsetParent !== null;

      if (isVisible) {
        const existingCustom = form.querySelector('.custom-swym-notify');
        if (existingCustom) existingCustom.remove();
        return;
      }
    }

    if (soldOutBtn) {
      if (form.querySelector('.custom-swym-notify')) return;

      const container =
        form.querySelector('.quantity-submit-row') || soldOutBtn.parentElement;
      if (!container) return;

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'btn btn--large custom-swym-notify';
      btn.innerText = 'Notify Me When Available';
      btn.style.marginTop = '10px';

      container.appendChild(btn);

      btn.addEventListener('click', function () {
        try {
          if (typeof _swat === 'undefined') {
            console.warn('SWYM not loaded');
            return;
          }

          const variantId =
            form.querySelector('input[name="id"]')?.value;
          const productId =
            form.querySelector('input[name="product-id"]')?.value;
          const productUrl = window.location.href;
          const productImg =
            document.querySelector('.product-media img')?.src || '';

          const priceText =
            document.querySelector('.price .money')?.textContent || '0';
          const priceValue =
            parseFloat(priceText.replace(/[^0-9.]/g, '')) || 0;

          let product = {
            epi: Number(variantId),
            empi: Number(productId),
            du: productUrl,
            iu: productImg,
            pr: priceValue,
            et: 8
          };

          let topic = 'comingsoon';
          let onSuccess = function (response) {
            console.log('SWYM popup opened', response);
          };

          _swat.addToWatchList(null, product, onSuccess, null, topic);
        } catch (e) {
          console.error('SWYM notify error', e);
        }
      });
    }
  } catch (e) {
    console.error('Notify button init failed', e);
  }
}
